export interface ServiceTier {
  id: number
  tierName: string
  description: string
  features: string[]
  imageSrc: string
}

interface DrupalAttributes {
  title: string
  field_description: string | string[] | Array<{ value: string }>
  field_features: string | string[] | Array<{ value: string }>
  field_image_path: string | null
  drupal_internal__nid: number
}

interface DrupalNode {
  type: string
  id: string
  attributes: DrupalAttributes
}

interface DrupalJsonApiResponse {
  data: DrupalNode[]
}

function extractText(field: string | string[] | Array<{ value: string }> | null | undefined): string {
  if (!field) return ''
  if (typeof field === 'string') return field.trim()
  if (Array.isArray(field)) {
    const first = field[0]
    if (!first) return ''
    return (typeof first === 'string' ? first : first.value).trim()
  }
  return ''
}

function extractMultiText(field: string | string[] | Array<{ value: string }> | null | undefined): string[] {
  if (!field) return []
  if (typeof field === 'string') return [field.trim()]
  if (Array.isArray(field)) {
    return field
      .map(item => (typeof item === 'string' ? item : item.value).trim())
      .filter(v => v.length > 0)
  }
  return []
}

function resolveImagePath(raw: string | null | undefined): string {
  if (!raw) return ''
  const cleaned = raw.trim()
  // Guard against accidental missing V prefix (e.g. "WKombi1.webp" instead of "VWKombi1.webp")
  if (cleaned.startsWith('WKombi')) return `/experience/V${cleaned}`
  return `/experience/${cleaned}`
}

export async function fetchServiceTiers(): Promise<ServiceTier[]> {
  const res = await fetch('/api/drupal/jsonapi/node/service_tier?sort=drupal_internal__nid')
  if (!res.ok) throw new Error(`Drupal API error: ${res.status}`)
  const json: DrupalJsonApiResponse = await res.json()

  return json.data.map((node, index) => ({
    id: index + 1,
    tierName: node.attributes.title,
    description: extractText(node.attributes.field_description),
    features: extractMultiText(node.attributes.field_features),
    imageSrc: resolveImagePath(node.attributes.field_image_path),
  }))
}
